import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getAllRole } from '@/pages/admins/role/api'

export const fetchGetAllRoleAsync = createAsyncThunk(
  'role/fetchGetAllRoleAsync',
  () =>
    axios
      .get(getAllRole())
      .then((response) => {
        return response?.data.items
      })
      .catch((e) => {
        console.log(e)
      })
)
const roleSlice = createSlice({
  name: 'role',
  initialState: {
    allRoles: null,
  },
  reducers: {
    updateAllRoles(state, action) {
      const roles = action.payload
      if (roles) {
        state.allRoles = roles
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetAllRoleAsync.pending, (state) => {
        state.allRoles = null
      })
      .addCase(fetchGetAllRoleAsync.fulfilled, (state, action) => {
        state.allRoles = action.payload
      })
  },
})

export const { updateAllRoles } = roleSlice.actions
export const getAllRoles = (state) => state.role.allRoles

export default roleSlice.reducer
